import PropTypes from 'prop-types';
import { formatCents } from '../../domain/finance';
import { useFinancialPrivacy } from '../../FinancialPrivacyContext';
import './styles.css';

export const HIDDEN_MONEY_PLACEHOLDER = 'R$ ••••••';

const SensitiveMoney = ({
  valueCents,
  semantic = 'neutral',
  showSign = false,
  absolute = false,
  as: Component = 'span',
  className = '',
  visible,
  variant = 'default',
}) => {
  const { valuesVisible } = useFinancialPrivacy();
  const shouldShow = typeof visible === 'boolean' ? visible : valuesVisible;
  const safeValue = Number.isFinite(valueCents) ? valueCents : 0;
  const formatted = formatCents(absolute ? Math.abs(safeValue) : safeValue);
  const sign = showSign
    ? semantic === 'income' ? '+ ' : semantic === 'expense' ? '− ' : ''
    : '';

  if (!shouldShow) {
    return (
      <Component className={`nf-sensitive-money nf-sensitive-money--${variant} ${className}`.trim()} aria-label="Valor oculto">
        <span aria-hidden="true">{HIDDEN_MONEY_PLACEHOLDER}</span>
      </Component>
    );
  }

  const match = formatted.match(/^(-)?\s*(R\$)\s*(.+),(\d{2})$/);
  if (!match) return <Component className={className}>{sign}{formatted}</Component>;
  const numericSign = match[1] ? '− ' : '';
  const visibleSign = sign || numericSign;
  const accessibleValue = `${sign}${formatted}`;

  return (
    <Component className={`nf-sensitive-money nf-sensitive-money--${variant} ${className}`.trim()} aria-label={accessibleValue}>
      <span aria-hidden="true" className="nf-sensitive-money__sign">{visibleSign.trim()}</span>
      <span aria-hidden="true" className="nf-sensitive-money__prefix">{match[2]}</span>
      <span aria-hidden="true" className="nf-sensitive-money__integer">{match[3]}</span>
      <span aria-hidden="true" className="nf-sensitive-money__cents">,{match[4]}</span>
    </Component>
  );
};

export const SensitiveMoneyGroup = ({
  children,
  as: Component = 'span',
  className = '',
  visible,
  variant = 'default',
}) => {
  const { valuesVisible } = useFinancialPrivacy();
  const shouldShow = typeof visible === 'boolean' ? visible : valuesVisible;

  if (!shouldShow) {
    return (
      <Component className={`nf-sensitive-money nf-sensitive-money--${variant} ${className}`.trim()} aria-label="Valor oculto">
        <span aria-hidden="true">{HIDDEN_MONEY_PLACEHOLDER}</span>
      </Component>
    );
  }

  return <Component className={className}>{children}</Component>;
};

SensitiveMoneyGroup.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.elementType,
  className: PropTypes.string,
  visible: PropTypes.bool,
  variant: PropTypes.oneOf(['hero', 'default', 'compact']),
};

SensitiveMoney.propTypes = {
  valueCents: PropTypes.number,
  semantic: PropTypes.oneOf(['income', 'expense', 'neutral']),
  showSign: PropTypes.bool,
  absolute: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  visible: PropTypes.bool,
  variant: PropTypes.oneOf(['hero', 'default', 'compact']),
};

export default SensitiveMoney;
